/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  CREATE_REASON_SUCCESS, // DELETE_REASON_SUCCESS,
  // GET_REASON_FAILURE,
  GET_REASON_LIST_FAILURE,
  GET_REASON_LIST_REQUEST,
  GET_REASON_LIST_SUCCESS,
  GET_REASON_REQUEST,
  GET_REASON_SUCCESS, // GET_REASON_TYPE_FAILURE,
  GET_REASON_TYPE_REQUEST,
  GET_REASON_TYPE_SUCCESS, // UPDATE_REASON_FAILURE,
  UPDATE_REASON_REQUEST,
  UPDATE_REASON_SUCCESS
} from "src/actions/reasonActions";

const initialState = {
  reasonTypeList: [],
  reasonList: [],
  reason: {},
  loadingGetReasonList: false
};

const reasonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REASON_TYPE_REQUEST: {
      return produce(state, (draft) => {
        draft.reasonTypeList = [];
      });
    }

    case GET_REASON_TYPE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.reasonTypeList = response;
      });
    }

    // case GET_REASON_TYPE_FAILURE: {
    //   return produce(state, (draft) => {
    //     // Maybe user error
    //   });
    // }

    case GET_REASON_LIST_REQUEST: {
      return produce(state, (draft) => {
        draft.reasonList = [];
        draft.loadingGetReasonList = true;
      });
    }

    case GET_REASON_LIST_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.reasonList = response;
        draft.loadingGetReasonList = false;
        draft.reasonList.sort((a, b) => (a?.priority || 0) - (b?.priority || 0));
      });
    }

    case CREATE_REASON_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.reason = response;
      });
    }

    case GET_REASON_LIST_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetReasonList = false;
      });
    }

    case GET_REASON_REQUEST: {
      return produce(state, (draft) => {
        draft.reason = {};
      });
    }

    case GET_REASON_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.reason = response;
      });
    }

    // case GET_REASON_FAILURE: {
    //   return produce(state, (draft) => {});
    // }

    // case DELETE_REASON_SUCCESS: {
    //   const { response } = action.payload;
    //   return produce(state, (draft) => {
    //   });
    // }

    case UPDATE_REASON_REQUEST: {
      return produce(state, (draft) => {
        draft.reason = {};
      });
    }

    case UPDATE_REASON_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.reason = response;
      });
    }

    // case UPDATE_REASON_FAILURE: {
    //   return produce(state, (draft) => {
    //     // Maybe user error
    //   });
    // }

    default: {
      return state; // We return the default state here
    }
  }
};

export default reasonReducer;
